import Immutable from 'immutable';

const initialState = Immutable.Map();
export default function device(state = initialState, action) {
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/referer.js